import { DoctorConfig } from '@app/icare/entities/doctor/config'
import { patientDoctorQueries } from '@app/icare/entities/doctor/queries/patientDoctorQueries'
import { PatientDoctorEditDrawer } from '@app/icare/entities/patient/edits/PatientDoctorEditDrawer'
import {
  patientFindingsQueryOptions,
  selectByGroupAndGroupByRelationId,
} from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientDoctorRelation } from '@app/icare/entities/patient/schema/PatientDoctor'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationOverview } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationOverview'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_doctor/praxen/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientDoctorQueries.forIndex(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: doctors = [] } = useSuspenseQuery(patientDoctorQueries.forIndex(id))
  const { data: findings = {} } = useQuery({
    ...patientFindingsQueryOptions(id),
    select: selectByGroupAndGroupByRelationId('doctors'),
  })
  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientDoctorRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/praxen/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })

  return (
    <RelationOverview
      items={doctors}
      labels={DoctorConfig}
      findings={findings}
      basePath={`/patienten/${id}/praxen`}
      onEdit={params =>
        void PatientDoctorEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
    />
  )
}
